import type {
    SavedArtworkViewListItemDto,
    LoadSavedArtworkViewResultDto,
    SaveArtworkViewRequest
} from "../models/SaveArtworkViewRequests";
import { useApiClient } from "../components/useApiClient";

export function useArtworkViewsApi() {
    const { get: getJson, putJson, postJson, delete: del } = useApiClient();

    async function getSavedArtworkViews(accessToken: string): Promise<SavedArtworkViewListItemDto[]> {
        return getJson<SavedArtworkViewListItemDto[]>("artworkviews/saved-views", accessToken);
    }

    async function getSavedArtworkViewById(id: number, accessToken: string): Promise<LoadSavedArtworkViewResultDto> {
        return getJson<LoadSavedArtworkViewResultDto>(`artworkviews/saved-views/${id}`, accessToken);
    }

    async function saveArtworkView(
        request: SaveArtworkViewRequest,
        accessToken: string
    ): Promise<LoadSavedArtworkViewResultDto> {
        return postJson<LoadSavedArtworkViewResultDto>("artworkviews/save", accessToken, request);
    }

    async function updateArtworkView(
        id: number,
        request: SaveArtworkViewRequest,
        accessToken: string
    ): Promise<LoadSavedArtworkViewResultDto> {
        return putJson<LoadSavedArtworkViewResultDto>(`artworkviews/update/${id}`, accessToken, request);
    }

    async function deleteSavedArtworkView(id: number, accessToken: string): Promise<void> {
        return del<void>(`artworkviews/${id}`, accessToken);
    }

    return {
        getSavedArtworkViews,
        getSavedArtworkViewById,
        saveArtworkView,
        updateArtworkView,
        deleteSavedArtworkView
    };
}